export default {
  ziEarthly: 'Tý',
  chouEarthly: 'Sửu',
  yinEarthly: 'Dần',
  maoEarthly: 'Mão',
  chenEarthly: 'Thìn',
  siEarthly: 'Tỵ',
  wuEarthly: 'Ngọ',
  weiEarthly: 'Mùi',
  shenEarthly: 'Thân',
  youEarthly: 'Dậu',
  xuEarthly: 'Tuất',
  haiEarthly: 'Hợi',
} as const;
